<template>
	<div>
		<Card no-body>
			<b-row v-if="headerTitle" align-v="center" slot="header">
				<b-col>
					<h3 class="mb-0">{{ headerTitle }}</h3>
				</b-col>
				<b-col v-if="headerButtonData" cols="4" class="text-right">
					<BaseButton
						@click="headerButtonClicked"
						:disabled="headerButtonData.isDisabled"
						size="sm"
						>{{ headerButtonData.title }}</BaseButton
					>
				</b-col>
			</b-row>
			<BaseInput v-if="canFilter"
				id="filter-input"
				v-model="filter"
				type="search"
				class="mb-0 mt-3 mx-3"
				placeholder="Type to Search"
				prependIcon="fa fa-search"
			></BaseInput>

			<b-table
				:fields="tableHeaders"
				:items="tableData"
				:busy="isLoading"
				:filter="filter"
				small
				hover
				responsive="sm"
				@row-clicked="rowClicked"
				class="px-1"
			>
				<template #table-busy>
					<b-overlay :show="isLoading" rounded="sm" no-wrap />
				</template>
				<template #cell(place)="data"> {{ data.index + 1 }} </template>
				<template #cell(score)="data"> {{ data.item.leaderboardScore }} </template>
				<template #cell(nameAndPhoto)="data">
					<b-img-lazy
						:src="
							data.item.profilePhotoURL
								? data.item.profilePhotoURL
								: 'https://firebasestorage.googleapis.com/v0/b/mysunday-v2.appspot.com/o/users%2FdefaultProfilePicture.png?alt=media&token=8488a06a-64ee-44b1-a4e3-10250d478545'
						"
						:text="data.item.firstName"
						rounded="circle"
						class="avatar-sm mr-2"
						style="object-fit: cover;"
					/>
					{{ data.item.firstName }} {{ data.item.lastName }}
				</template>
				<template #cell(username)="data"> @{{ data.item.username }} </template>
				<template #cell(uid)="data">
					{{ getCensored(data.item.uid) }}
				</template>
				<template #cell(waiverStatus)="data">
					<BaseSwitch
						:value="data.value"
						:isDisabled="true"
						:type="data.value ? 'success' : 'primary'"
					/>
				</template>
				<template #cell(subscriptionStatus)="data">
					<BaseSwitch
						:value="data.value"
						:isDisabled="true"
						:type="data.value ? 'success' : 'primary'"
					/>
				</template>
				<template #cell(attendanceStatus)="data">
					<BaseSwitch
						:value="data.value"
						:type="'success'"
						@input="switchChanged($event, data)"
					/>
				</template>
				<template #cell(member-actions)="row">
					<b-dropdown id="actions" variant="null" dropleft no-caret class="m-0 p-0"
						><template #button-content><i class="fas fa-ellipsis-v"></i> </template>
						<b-dropdown-item @click="generateQRCode(row.item)"
							>Generate Badge</b-dropdown-item
						>
						</b-dropdown>
				</template>
				<template #cell(actions)="row">
					<b-dropdown id="actions" variant="null" dropleft no-caret class="m-0 p-0"
						><template #button-content><i class="fas fa-ellipsis-v"></i> </template>
						<b-dropdown-item @click="newPassClicked(row.item)"
							>New Password</b-dropdown-item
						>
						<b-dropdown-item @click="resendClicked(row.item)"
							>Resend Email</b-dropdown-item
						>
						
						<b-dropdown-divider></b-dropdown-divider>
						<b-dropdown-item variant="danger" @click="deleteClicked(row.item)"
							>Delete Member</b-dropdown-item
						>
					</b-dropdown>
				</template>
			</b-table>
			<hr class="my-2" />
			<b-row v-if="showFooter">
				<b-col></b-col>
				<b-col class="text-right">
					<h5 class="mx-2 description text-muted">Total: {{ tableData.length }}</h5>
				</b-col>
			</b-row>
		</Card>
	</div>
</template>
<script>
import BaseButton from '../../../components/BaseButton.vue';
import BaseSwitch from '../../../components/BaseSwitch.vue';
import BaseInput from '../../../components/Inputs/BaseInput.vue';
import Card from '../../../components/Cards/Card.vue';
export default {
	components: { BaseButton, BaseSwitch, BaseInput, Card },
	computed: {
		sortOptions() {
			// Create an options list from our fields
			return this.fields
				.filter((f) => f.sortable)
				.map((f) => {
					return { text: f.label, value: f.key };
				});
		},
	},
	props: {
		isLoading: false,
		canFilter: {
			type: Boolean,
			default: true
		},
		showFooter: {
			type: Boolean,
			default: true
		},
		filter: null,
		headerTitle: {
			type: String,
			default: null,
		},
		headerButtonData: {
			type: Object,
			default: null,
		},
		tableHeaders: {
			type: Array,
			description: 'The fields or table headers',
		},
		tableData: {
			type: Array,
			description: 'Data for table',
		},
	},
	data() {
		return {};
	},
	methods: {
		headerButtonClicked() {
			this.$emit('headerButtonClicked');
		},
		getCensored(uid){
			//{{ data.item.uid.slice(0, 10) }}****
			return uid
		},
		switchChanged(value, data) {
			this.$emit('onChanged', {
				value: value,
				data: data.item,
			});
		},
		generateQRCode(item){
			this.$emit('generateQRCode', item);
		},
		resendClicked(item) {
			this.$emit('resendClicked', item);
		},
		newPassClicked(item) {
			this.$emit('newPassClicked', item);
		},
		rowClicked(item) {
			this.$emit('viewClicked', item);
		},
		deleteClicked(item) {
			this.$emit('deleteClicked', item);
		},
	},
};
</script>
